import { render, staticRenderFns } from "./StoriesDetail.vue?vue&type=template&id=9b619942&"
import script from "./StoriesDetail.vue?vue&type=script&lang=js&"
export * from "./StoriesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports